import React from 'react';
import moment from 'moment';
import { FaLock } from 'react-icons/all';
import { Link } from 'react-router-dom';
import i18n, { getDateFormatOptions } from '@/utils/i18n';

const getName = function (deliveryInfo: any): string {
  if (deliveryInfo.given_name) {
    return `${deliveryInfo.given_name} ${deliveryInfo.family_name}`;
  } else {
    return deliveryInfo.family_name;
  }
};

export const OrderOverview = function ({
  order,
  isAdmin,
}: {
  order: any;
  isAdmin: boolean;
}) {
  const { user } = order;

  return (
    <>
      <dl className="row">
        <dt className="col-sm-3">{i18n.t('Order:type')}</dt>
        <dd className="col-sm-9">
          {i18n.t(`Order:OrderType:${order.type}`, i18n.t('Common:unknown'))}
        </dd>

        <dt className="col-sm-3">{i18n.t('Order:location')}</dt>
        <dd className="col-sm-9">
          <a
            href={
              order.vending_machine != null
                ? `/vending-machine/${order.store.id}/${order.vending_machine.id}`
                : `/pickpack/stores/${order.store.id}`
            }
          >
            {(order.vending_machine || order.store).name}
          </a>
        </dd>

        <dt className="col-sm-3">{i18n.t('Common:status')}</dt>
        <dd className="col-sm-9" title={order.status}>
          {i18n.t(`Order:Status:${order.status}`, order.status) as string}
        </dd>

        <dt className="col-sm-3">
          {order.type === 'DELIVERY_ORDER'
            ? i18n.t('Order:deliveryTime')
            : i18n.t('Order:pickupTime')}
        </dt>
        <dd className="col-sm-9">
          {order.type === 'INSTANT_ORDER'
            ? i18n.t('Order:asap')
            : moment(order.pickup_time).format('HH:mm - DD.MM.YYYY')}
        </dd>

        <dt className="col-sm-3">{i18n.t('Order:createdAt')}</dt>
        <dd className="col-sm-9">
          {new Date(order.created_at).toLocaleDateString(
            i18n.language,
            getDateFormatOptions(true),
          )}
        </dd>

        <dt className="col-sm-3"> {i18n.t('Order:isExternal')}</dt>
        <dd className="col-sm-9">
          {order.external_id !== null
            ? i18n.t('Common:yes')
            : i18n.t('Common:no')}
        </dd>

        {isAdmin && (
          <>
            <dt className="col-sm-3">
              <FaLock size="13" /> User
            </dt>
            <dd className="col-sm-9">
              {user.id.includes('vytal_') ? (
                <Link to={'/users/' + user.external_id.replace('vytal_', '')}>
                  {user.email || user.name || user.id}
                </Link>
              ) : (
                <>
                  Pickpack user:{' '}
                  {[user.id, user.email].filter((val) => val).join(', ')}
                </>
              )}
            </dd>
          </>
        )}

        <dt className="col-sm-3">{i18n.t('Order:rating')}</dt>
        <dd className="col-sm-9">
          {order.user_rating || '-'} {order.feedback || ''}
        </dd>
      </dl>

      {order.type === 'DELIVERY_ORDER' && order.delivery_address && (
        <>
          <h4>{i18n.t('Order:deliveryAddress')}</h4>
          <dl className="row">
            <dt className="col-sm-3">{i18n.t('Common:name')}</dt>
            <dd className="col-sm-9">{getName(order.delivery_address)}</dd>
            <dt className="col-sm-3">{i18n.t('Common:street')}</dt>
            <dd className="col-sm-9">
              {order.delivery_address.streetname +
                ' ' +
                order.delivery_address.streetno}
            </dd>
            <dt className="col-sm-3">{i18n.t('Order:zipCodeAndCity')}</dt>
            <dd className="col-sm-9">
              {order.delivery_address.zip + ' ' + order.delivery_address.city}
            </dd>
            {order.delivery_address.phone_number && (
              <>
                <dt className="col-sm-3">{i18n.t('Common:phonenumber')}</dt>
                <dd className="col-sm-9">
                  {order.delivery_address.phone_number}
                </dd>
              </>
            )}
            {order.delivery_address.additional_info && (
              <>
                <dt className="col-sm-3">{i18n.t('Order:additionalInfo')}</dt>
                <dd className="col-sm-9">
                  {order.delivery_address.additional_info}
                </dd>
              </>
            )}
          </dl>
        </>
      )}
    </>
  );
};
